import {Injectable} from '@angular/core';
import {SupportInformation} from '../models/SupportInformation.model';

@Injectable({providedIn: 'root'})

export class DataService {
  public PhoneNumber: string = '';
  public EmailAddress: string = '';
  public MailingAddress: string = '';
  public WeekdayHours: string = '';
  public WeekendHours: string = '';
  public ProfileName: string = '';

  public setSupportInfo(supportInfo: SupportInformation): void {
    this.PhoneNumber = supportInfo.PhoneNumber;
    this.EmailAddress = supportInfo.EmailAddress;
    this.MailingAddress = supportInfo.MailingAddress;
    this.WeekdayHours = supportInfo.WeekdayHours;
    this.WeekendHours = supportInfo.WeekendHours;
    this.ProfileName = supportInfo.ProfileName;
  }
}
